import { trackMealPlanPageLoad } from 'analytics/trackers/nutrition';
import { useEffect } from 'react';

import { Calendar } from 'components';

import { useGetMealPlan } from './hooks/useGetMealPlan';

import * as S from './styled';

export const MealPlanModule = () => {
    const { getMealPlan, listContent, selectedDate, setSelectedDate, state } = useGetMealPlan();

    useEffect(() => {
        getMealPlan(selectedDate);
    }, [getMealPlan, selectedDate]);

    useEffect(() => {
        if (state === 'filled' || state === 'empty') {
            trackMealPlanPageLoad();
        }
    }, [state]);

    const handleDateChange = (date: Date) => {
        setSelectedDate(date);
        getMealPlan(date);
    };

    return (
        <S.Container data-locator="meal-plan-module" data-testid="meal-plan-module">
            <S.MealsContainer>
                <Calendar selectedDate={selectedDate} onDateChange={handleDateChange} layout="today-first" />
                {listContent}
            </S.MealsContainer>
        </S.Container>
    );
};
